/* eslint-disable no-restricted-globals */
import numeral from 'numeral';
import {
  LOCALE_PT_JP,
  LOCALE_PT_US,
  LOCALE_PT_UK,
  LOCALE_PT_PT,
  LOCALE_PT_AO,
  LOCALE_PT_BR,
  LOCALE_PT_IE,
  LOCALE_PT_BO,
  LOCALE_PT_IT,
} from '../locale/localeConstants';

const LOCALE_SETTINGS = {
  [LOCALE_PT_JP]: {
    locale: LOCALE_PT_JP,
    localCode: 'ja',
    currencyFormat: '$ 0,0',
  },
  [LOCALE_PT_US]: {
    locale: LOCALE_PT_US,
    localCode: 'en',
    currencyFormat: '$ 0,0.00',
  },
  [LOCALE_PT_UK]: {
    locale: LOCALE_PT_UK,
    localCode: 'en-gb',
    currencyFormat: '$ 0,0.00',
  },
  [LOCALE_PT_PT]: {
    locale: LOCALE_PT_PT,
    localCode: 'pt-pt',
    currencyFormat: '0,0.00 $',
  },
  [LOCALE_PT_AO]: {
    locale: LOCALE_PT_AO,
    localCode: 'pt-ao',
    currencyFormat: '0,0$',
  },
  [LOCALE_PT_IE]: {
    locale: LOCALE_PT_IE,
    localCode: 'pt-pt',
    currencyFormat: '0,0.00 $',
  },
  [LOCALE_PT_BO]: {
    locale: LOCALE_PT_BO,
    localCode: 'pt-bo',
    currencyFormat: '$ 0,0.00',
  },
  [LOCALE_PT_IT]: {
    locale: LOCALE_PT_IT,
    localCode: 'pt-it',
    currencyFormat: '0,0.00 $',
  },
  [LOCALE_PT_BR]: {
    locale: LOCALE_PT_BR,
    localCode: 'pt-br',
    currencyFormat: '$ 0,0.00',
  },
};

function getLocaleSettings(locale) {
  if (!locale) {
    return LOCALE_SETTINGS[LOCALE_PT_BR];
  }
  return LOCALE_SETTINGS[locale] ?? LOCALE_SETTINGS[LOCALE_PT_BR];
}

let selectedLocaleSettings = getLocaleSettings();

const BASE_DECIMAL_FORMAT = '0,0';
const BASE_PERCENT_FORMAT = '0%';
const NumberUtils = {
  toCurrency: (value) => {
    return numeral(value).format(selectedLocaleSettings.currencyFormat);
  },

  toPercent: (value, fractionDigits = 0) => {
    let fractionPart = '';
    if (fractionDigits && fractionDigits > 0) {
      const fractionZeroes = '0'.padEnd(fractionDigits, '0');
      fractionPart = `.${fractionZeroes}`;
    }

    return value != null && !isNaN(value)
      ? numeral(value).format(`${BASE_PERCENT_FORMAT}${fractionPart}`)
      : value;
  },

  toDecimals: (value, fractionDigits = 0) => {
    let fractionPart = '';
    if (fractionDigits && fractionDigits > 0) {
      const fractionZeroes = '0'.padEnd(fractionDigits, '0');
      fractionPart = `.${fractionZeroes}`;
    }

    return value != null && !isNaN(value)
      ? numeral(value).format(`${BASE_DECIMAL_FORMAT}${fractionPart}`)
      : value;
  },

  formatAsPercent: (value, fractionDigits = 0) => {
    return `${NumberUtils.toDecimals(value, fractionDigits)}%`;
  },

  setLocale: (localeString) => {
    selectedLocaleSettings = getLocaleSettings(localeString);
    numeral.locale(selectedLocaleSettings.localCode);
  },
};
export default NumberUtils;
